/**
 * @generated SignedSource<<61fef4835832a14fffed4feb2fd16d5c>>
 * @relayHash 8095f723e4b598338c3c3c8c18e763ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4a61a337d185f6e4afefb5bbff2cb0c4bc7f4a4776f29c7eed0049af5f812ec

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type ContentUnifiedWithSpaceKeyQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  autohighlightsEntityAri?: string | null;
  autohighlightsWorkspaceId?: string | null;
  cloudId?: string | null;
  externalLabelsAri?: string | null;
  externalLabelsCloudId?: string | null;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeAudioContent?: boolean | null;
  includeAutohighlights?: boolean | null;
  includeAutomationDiscoveries?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeConnectionAncestors?: boolean | null;
  includeContentHeader?: boolean | null;
  includeContentHeaderAccess?: boolean | null;
  includeExternalLabels?: boolean | null;
  includeFabricEditorEligibility?: boolean | null;
  includeNumberedHeadings?: boolean | null;
  includeReactions?: boolean | null;
  includeRendererAssetsCustomChrome?: boolean | null;
  includeRendererAssetsMedia?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  includeRovoMentionIdentity?: boolean | null;
  includeSmartCreateFeedback?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey: string;
  useClassificationLevelV2?: boolean | null;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedWithSpaceKeyQuery$data = {
  readonly agentStudio_getAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly identityAccountId: string | null;
      } | null;
    }>;
  } | null;
  readonly autohighlightsQueryFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  } | null;
  readonly externalLabelsFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"useExternalLabels_query">;
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly space: {
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_space">;
    } | null;
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
    };
    readonly settings: {
      readonly customHeaderAndFooter: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled?: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_space">;
  } | null;
  readonly spaceHomepage: {
    readonly agentSessionsMarker?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly archivedPageBannerStatusFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
    };
    readonly audioContent?: {
      readonly audioProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emoji: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly history: {
        readonly createdBy: {
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
        readonly ownedBy: {
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly links: {
        readonly base: string | null;
        readonly webui: string | null;
      } | null;
      readonly subType: string | null;
      readonly title: string | null;
    } | null;
    readonly audioContentFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"AudioContentFragment_content">;
    } | null;
    readonly body: {
      readonly atlas_doc_format?: {
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
      } | null;
      readonly dynamic: {
        readonly content: {
          readonly id: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null;
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly superbatch: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly bylineClassificationFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
    } | null;
    readonly commentsPanelPermission: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
    };
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_content">;
    } | null;
    readonly contentProperties: {
      readonly draft: {
        readonly contentMode: string | null;
      } | null;
      readonly latest: {
        readonly contentMode: string | null;
        readonly generatedBy?: string | null;
      } | null;
    } | null;
    readonly contentState: {
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null;
    readonly contentStateLastUpdated: {
      readonly value: string;
    } | null;
    readonly contentTitleWithByLine?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
    } | null;
    readonly coverPicture?: {
      readonly coverPictureProperties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
    } | null;
    readonly draftVersion: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly history?: {
      readonly createdBy: {
        readonly displayName: string | null;
      } | null;
      readonly createdDate: string | null;
    } | null;
    readonly id: string | null;
    readonly labels?: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    } | null;
    readonly meetingNotesAutomationDiscoveryFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscoveryFragment_content">;
    } | null;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null;
        readonly coverPictureWidth?: string | null;
        readonly embedded: boolean;
        readonly fabricEditorSupported: boolean | null;
      } | null;
      readonly lastModifiedDate: string | null;
    };
    readonly numberedHeadingsPublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
    };
    readonly pageRestrictionsContext?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
    } | null;
    readonly pageRestrictionsContextAncestors?: {
      readonly ancestors: ReadonlyArray<{
        readonly hasRestrictions: boolean;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly id: string | null;
    } | null;
    readonly pageTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly reactionsContent?: {
      readonly contentReactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly id: string | null;
    } | null;
    readonly reactionsContentFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
    } | null;
    readonly rendererAssetsMacroOutput?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_content">;
    } | null;
    readonly rendererAssetsMedia?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent">;
    } | null;
    readonly rendererCoverPicture?: {
      readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
    } | null;
    readonly rendererTitleContentProperties?: {
      readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
    } | null;
    readonly shareAndRestrictButtonData?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
      readonly title: string | null;
    } | null;
    readonly smartFolderProperties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
      readonly type: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly titleContentProperties?: {
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth: string | null;
        } | null;
      };
      readonly pageTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly type: string | null;
    readonly version: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly confRev: string | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly viewPageContentMode?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
    } | null;
    readonly viewPageLabels?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
    } | null;
  } | null;
};
export type ContentUnifiedWithSpaceKeyQuery$rawResponse = {
  readonly agentStudio_getAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly identityAccountId: string | null;
      } | null;
    }>;
  } | null;
  readonly confluence_externalLabels?: ReadonlyArray<{
    readonly id: string | null;
    readonly kind: string | null;
    readonly name: string | null;
  } | null> | null;
  readonly knowledgeDiscovery?: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      readonly __typename: string;
    } | null;
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly header: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
      readonly headings: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null>;
    } | null;
    readonly settings: {
      readonly customHeaderAndFooter?: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
  } | null;
  readonly spaceHomepage: {
    readonly agentSessionsMarker?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly ancestors?: ReadonlyArray<{
      readonly hasRestrictions?: boolean;
      readonly history: {
        readonly createdBy: {
          readonly __typename: string;
          readonly displayName: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly links?: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly audioProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly body: {
      readonly atlas_doc_format?: {
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
      } | null;
      readonly dynamic: {
        readonly content: {
          readonly id: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null;
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly superbatch: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly classificationLevelDetails?: {
      readonly canManageSpaceSettings: boolean;
      readonly classificationControlSetting: string | null;
      readonly classificationLevel?: {
        readonly color: string | null;
        readonly description: string | null;
        readonly guideline: string | null;
        readonly guidelineADF: string | null;
        readonly id: string;
        readonly name: string;
        readonly status: string;
      } | null;
      readonly classificationLevelV2?: {
        readonly color: string | null;
        readonly description: string | null;
        readonly guideline: string | null;
        readonly guidelineADF: string | null;
        readonly id: string;
        readonly name: string;
        readonly status: string;
      };
      readonly featureEnabled: boolean;
      readonly isReclassificationPermitted: boolean;
      readonly source: ClassificationLevelSource | null;
      readonly userOverrideSetting: string | null;
    } | null;
    readonly contentProperties: {
      readonly draft: {
        readonly contentMode: string | null;
        readonly generatedBy?: string | null;
      } | null;
      readonly latest: {
        readonly contentMode: string | null;
        readonly generatedBy: string | null;
      } | null;
    } | null;
    readonly contentReactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null>;
    } | null;
    readonly contentState: {
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null;
    readonly contentStateLastUpdated: {
      readonly value: string;
    } | null;
    readonly coverPictureProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly creatorId?: string | null;
    readonly draftVersion: {
      readonly by: {
        readonly __typename: string;
        readonly displayName: string | null;
      } | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly editorProperty?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly emoji?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly emojiTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly hasViewRestrictions?: boolean;
    readonly history?: {
      readonly createdBy: {
        readonly __typename: "KnownUser";
        readonly accountId: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | {
        readonly __typename: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | null;
      readonly createdDate: string | null;
      readonly lastOwnedBy: {
        readonly __typename: "KnownUser";
        readonly accountId: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | {
        readonly __typename: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | null;
      readonly ownedBy: {
        readonly __typename: "KnownUser";
        readonly accountId: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | {
        readonly __typename: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly labels?: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly __typename: "Label";
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    } | null;
    readonly links?: {
      readonly base: string | null;
      readonly webui: string | null;
    } | null;
    readonly macroRenderedOutput?: ReadonlyArray<{
      readonly key: string | null;
      readonly value: {
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null;
        readonly contentHash?: string | null;
        readonly coverPictureWidth: string | null;
        readonly embedded: boolean;
        readonly fabricEditorEligibility?: string | null;
        readonly fabricEditorSupported: boolean | null;
      } | null;
      readonly lastModifiedDate: string | null;
      readonly sourceTemplateEntityId: string | null;
    };
    readonly numberedHeadingsPublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTitleDraft?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly pageTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly smartFolderProperties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly space: {
      readonly alias: string | null;
      readonly homepageId?: string | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
      readonly type: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly version: {
      readonly by: {
        readonly __typename: "KnownUser";
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly profilePicture?: {
          readonly path: string;
        } | null;
        readonly type?: string | null;
      } | {
        readonly __typename: string;
        readonly displayName: string | null;
        readonly profilePicture?: {
          readonly path: string;
        } | null;
        readonly type?: string | null;
      } | null;
      readonly confRev: string | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
  } | null;
};
export type ContentUnifiedWithSpaceKeyQuery = {
  rawResponse: ContentUnifiedWithSpaceKeyQuery$rawResponse;
  response: ContentUnifiedWithSpaceKeyQuery$data;
  variables: ContentUnifiedWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsEntityAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsWorkspaceId"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "externalLabelsAri"
},
v5 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "externalLabelsCloudId"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAudioContent"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutohighlights"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscoveries"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeConnectionAncestors"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeader"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderAccess"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeExternalLabels"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFabricEditorEligibility"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNumberedHeadings"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsCustomChrome"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsMedia"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRovoMentionIdentity"
},
v25 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSmartCreateFeedback"
},
v26 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v27 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v29 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useClassificationLevelV2"
},
v30 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v31 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v33 = [
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v34 = {
  "kind": "ScalarField",
  "name": "id"
},
v35 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "type"
},
v37 = {
  "kind": "ScalarField",
  "name": "status"
},
v38 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v39 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v38/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v38/*: any*/)
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "name"
},
v41 = {
  "kind": "ScalarField",
  "name": "color"
},
v42 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v43 = {
  "kind": "ScalarField",
  "name": "value"
},
v44 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v43/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v45 = {
  "kind": "ScalarField",
  "name": "title"
},
v46 = {
  "kind": "ScalarField",
  "name": "key"
},
v47 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v40/*: any*/),
    (v46/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v36/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "subType"
},
v49 = [
  (v46/*: any*/),
  (v43/*: any*/)
],
v50 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v49/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v51 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v52 = {
  "kind": "ScalarField",
  "name": "number"
},
v53 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v54 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v55 = [
  (v54/*: any*/)
],
v56 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = {
  "kind": "ScalarField",
  "name": "when"
},
v58 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v59 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v60 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v59/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "representation"
},
v62 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v52/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "js"
},
v64 = {
  "kind": "ScalarField",
  "name": "css"
},
v65 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    (v63/*: any*/),
    (v64/*: any*/)
  ]
},
v66 = [
  (v65/*: any*/)
],
v67 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v43/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v62/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v66/*: any*/)
            },
            (v65/*: any*/)
          ]
        }
      ]
    }
  ]
},
v68 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v34/*: any*/),
      (v46/*: any*/),
      (v43/*: any*/),
      (v62/*: any*/)
    ]
  }
],
v69 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v70 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v71 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v72 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v73 = {
  "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
  "kind": "LinkedField",
  "name": "frontend",
  "plural": false,
  "selections": (v59/*: any*/)
},
v74 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v73/*: any*/)
  ]
},
v75 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v76 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v77 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v78 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v79 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v80 = {
  "kind": "ScalarField",
  "name": "count"
},
v81 = {
  "kind": "ScalarField",
  "name": "label"
},
v82 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v83 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v80/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v34/*: any*/)
      ]
    }
  ]
},
v84 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "emoji-title-published"
  }
],
v85 = {
  "alias": "emoji",
  "args": (v84/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v34/*: any*/),
        (v43/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v86 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v87 = [
  (v54/*: any*/),
  (v86/*: any*/)
],
v88 = {
  "kind": "ScalarField",
  "name": "webui"
},
v89 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    (v88/*: any*/),
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v90 = {
  "alias": "audioProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v43/*: any*/),
        (v46/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
},
v91 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v34/*: any*/),
    (v45/*: any*/),
    (v77/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        (v88/*: any*/)
      ]
    }
  ]
},
v92 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v34/*: any*/),
      (v46/*: any*/),
      (v43/*: any*/)
    ]
  }
],
v93 = {
  "condition": "includeNumberedHeadings",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "numberedHeadingsPublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "numbered-headings-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v92/*: any*/),
      "storageKey": "properties(key:\"numbered-headings-published\")"
    }
  ]
},
v94 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v95 = [
  {
    "kind": "ScalarField",
    "name": "generatedBy"
  }
],
v96 = {
  "concreteType": "PublishedContentProperties",
  "kind": "LinkedField",
  "name": "latest",
  "plural": false,
  "selections": (v95/*: any*/)
},
v97 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    (v96/*: any*/)
  ]
},
v98 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "atlas_doc_format",
      "plural": false,
      "selections": [
        {
          "concreteType": "EmbeddedMediaToken",
          "kind": "LinkedField",
          "name": "mediaToken",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "token"
            }
          ]
        }
      ]
    }
  ]
},
v99 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v68/*: any*/)
    }
  ]
},
v100 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v101 = {
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "themeKey"
    },
    (v40/*: any*/)
  ]
},
v102 = {
  "kind": "ScalarField",
  "name": "background"
},
v103 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v104 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v105 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v106 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v107 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v108 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v109 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v110 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v111 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v112 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v102/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    (v105/*: any*/),
    (v106/*: any*/),
    (v107/*: any*/),
    (v108/*: any*/),
    (v109/*: any*/),
    (v110/*: any*/),
    (v111/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v102/*: any*/),
        (v103/*: any*/),
        (v104/*: any*/),
        (v105/*: any*/),
        (v106/*: any*/),
        (v107/*: any*/),
        (v108/*: any*/),
        (v109/*: any*/),
        (v110/*: any*/),
        (v111/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v113 = {
  "kind": "ScalarField",
  "name": "padding"
},
v114 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v115 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v102/*: any*/),
    (v103/*: any*/),
    (v104/*: any*/),
    (v105/*: any*/),
    (v106/*: any*/),
    (v107/*: any*/),
    (v108/*: any*/),
    (v109/*: any*/),
    (v110/*: any*/),
    (v111/*: any*/),
    (v113/*: any*/),
    (v114/*: any*/)
  ]
},
v116 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v117 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v118 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  (v63/*: any*/),
  (v64/*: any*/),
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      (v40/*: any*/)
    ]
  }
],
v119 = {
  "condition": "includeRendererAssetsCustomChrome",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "SpaceSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "concreteType": "SpaceSettingsMetadata",
          "kind": "LinkedField",
          "name": "customHeaderAndFooter",
          "plural": false,
          "selections": [
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": (v118/*: any*/)
            },
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "footer",
              "plural": false,
              "selections": (v118/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v120 = {
  "condition": "includeRendererAssetsMedia",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MediaConfiguration",
      "kind": "LinkedField",
      "name": "mediaConfiguration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "clientId"
        },
        {
          "kind": "ScalarField",
          "name": "fileStoreUrl"
        }
      ]
    }
  ]
},
v121 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "creatorTypes": [
        "ROVO_CHAT"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "product",
    "value": "confluence"
  }
],
v122 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v123 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "autohighlightsEntityAri"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "autohighlightsWorkspaceId"
  }
],
v124 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "externalLabelsCloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "externalLabelsAri"
  }
],
v125 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v126 = [
  (v125/*: any*/),
  (v54/*: any*/)
],
v127 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v126/*: any*/)
},
v128 = {
  "kind": "ScalarField",
  "name": "sourceTemplateEntityId"
},
v129 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v130 = [
  (v125/*: any*/),
  (v36/*: any*/),
  (v54/*: any*/),
  (v129/*: any*/),
  (v86/*: any*/)
],
v131 = {
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v126/*: any*/)
},
v132 = [
  (v76/*: any*/),
  (v77/*: any*/),
  (v78/*: any*/)
],
v133 = [
  (v125/*: any*/),
  (v54/*: any*/),
  (v86/*: any*/)
],
v134 = [
  (v34/*: any*/),
  {
    "kind": "ScalarField",
    "name": "guideline"
  },
  {
    "kind": "ScalarField",
    "name": "guidelineADF"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  (v41/*: any*/),
  (v40/*: any*/),
  (v37/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v33/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          (v42/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v50/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/)
            ]
          },
          (v60/*: any*/),
          (v67/*: any*/),
          (v69/*: any*/),
          (v70/*: any*/),
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ViewPageCommentsPanelPermission_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "commentsPanelPermission"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ArchivedPageBannerV2Status_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "archivedPageBannerStatusFragment"
          },
          {
            "condition": "useContentModeFragment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentModeFragmentProvider_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageContentMode"
              }
            ]
          },
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeConnectionAncestors",
                          "variableName": "includeConnectionAncestors"
                        },
                        {
                          "kind": "Variable",
                          "name": "useNewContentTopper",
                          "variableName": "useNewContentTopper"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentTitleWithByLine_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTitleWithByLine"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useTitleContentPropertiesForPublishedPage_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererTitleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "CoverPictureQuery_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererCoverPicture"
              }
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "MeetingNotesAutomationDiscoveryFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "meetingNotesAutomationDiscoveryFragment"
              }
            ]
          },
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeAccessButton",
                          "variableName": "includeContentHeaderAccess"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeFabricEditorEligibility",
                          "variableName": "includeFabricEditorEligibility"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeSmartCreateFeedback",
                          "variableName": "includeSmartCreateFeedback"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v71/*: any*/),
                    (v72/*: any*/),
                    (v74/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "titleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v75/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "coverPicture"
              },
              (v71/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v76/*: any*/),
                    (v77/*: any*/),
                    (v78/*: any*/),
                    (v45/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "shareAndRestrictButtonData"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v76/*: any*/),
                    (v78/*: any*/),
                    (v77/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContext"
              }
            ]
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageLabelsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageLabels"
              },
              {
                "args": (v79/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v34/*: any*/),
                      (v81/*: any*/),
                      (v40/*: any*/),
                      (v82/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v83/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContent"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ReactionsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContentFragment"
              }
            ]
          },
          {
            "condition": "includeAudioContent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v45/*: any*/),
                    (v48/*: any*/),
                    (v85/*: any*/),
                    {
                      "concreteType": "History",
                      "kind": "LinkedField",
                      "name": "history",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "createdBy",
                          "plural": false,
                          "selections": (v87/*: any*/)
                        },
                        {
                          "kind": "LinkedField",
                          "name": "ownedBy",
                          "plural": false,
                          "selections": (v87/*: any*/)
                        }
                      ]
                    },
                    (v89/*: any*/),
                    (v90/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "audioContent"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "AudioContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "audioContentFragment"
              }
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v34/*: any*/),
                    (v91/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContextAncestors"
              }
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "useClassificationLevelV2",
                          "variableName": "useClassificationLevelV2"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "BylineClassification_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "bylineClassificationFragment"
              }
            ]
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          },
          (v93/*: any*/),
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v55/*: any*/)
                  }
                ]
              },
              (v97/*: any*/)
            ]
          },
          {
            "condition": "includeRendererAssetsMedia",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v98/*: any*/),
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererAssetsMedia"
              }
            ]
          },
          {
            "condition": "isSSR",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererAssetsMacroOutput"
              }
            ]
          },
          (v99/*: any*/)
        ]
      },
      {
        "args": (v100/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v101/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v112/*: any*/),
                  (v115/*: any*/)
                ]
              }
            ]
          },
          (v116/*: any*/),
          (v117/*: any*/),
          (v119/*: any*/),
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_space"
                    }
                  ],
                  "type": "Space"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_space"
                }
              ],
              "type": "Space"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          }
        ]
      },
      (v120/*: any*/),
      {
        "condition": "includeRovoMentionIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v121/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v122/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v123/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "preloadAutohighlightsQuery_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "autohighlightsQueryFragment"
          }
        ]
      },
      {
        "condition": "includeExternalLabels",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v124/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "useExternalLabels_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "externalLabelsFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v28/*: any*/),
      (v32/*: any*/),
      (v24/*: any*/),
      (v3/*: any*/),
      (v26/*: any*/),
      (v21/*: any*/),
      (v20/*: any*/),
      (v31/*: any*/),
      (v27/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v23/*: any*/),
      (v22/*: any*/),
      (v12/*: any*/),
      (v29/*: any*/),
      (v14/*: any*/),
      (v25/*: any*/),
      (v15/*: any*/),
      (v17/*: any*/),
      (v30/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v16/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v33/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          (v42/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v50/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v127/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v127/*: any*/),
              (v57/*: any*/)
            ]
          },
          (v60/*: any*/),
          (v67/*: any*/),
          (v69/*: any*/),
          (v70/*: any*/),
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "emojiTitlePublished",
                "args": (v84/*: any*/),
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v68/*: any*/),
                "storageKey": "properties(key:\"emoji-title-published\")"
              },
              {
                "alias": "editorProperty",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "editor"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v92/*: any*/),
                "storageKey": "properties(key:\"editor\")"
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v73/*: any*/),
                  (v128/*: any*/)
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "homepageId"
                  }
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v130/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v130/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v130/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v86/*: any*/),
                      (v129/*: any*/)
                    ]
                  }
                ]
              },
              (v97/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v75/*: any*/),
              {
                "condition": "includeConnectionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "ancestors",
                    "plural": true,
                    "selections": [
                      (v34/*: any*/),
                      (v45/*: any*/),
                      (v36/*: any*/),
                      (v48/*: any*/),
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          (v131/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                              "devdocsProperties",
                              "smartFolderProperties"
                            ]
                          }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": (v92/*: any*/),
                        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v128/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "includeFabricEditorEligibility",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fabricEditorEligibility"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "contentHash"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeSmartCreateFeedback",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "creatorId"
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v94/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DraftContentProperties",
                        "kind": "LinkedField",
                        "name": "draft",
                        "plural": false,
                        "selections": (v95/*: any*/)
                      },
                      (v96/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "includeContentHeaderAccess",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v132/*: any*/)
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v71/*: any*/),
              (v72/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v132/*: any*/)
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v79/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v125/*: any*/),
                      (v34/*: any*/),
                      (v81/*: any*/),
                      (v40/*: any*/),
                      (v82/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v83/*: any*/)
            ]
          },
          {
            "condition": "includeAudioContent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v85/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v133/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v133/*: any*/)
                  }
                ]
              },
              (v89/*: any*/),
              (v90/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v91/*: any*/)
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ClassificationLevelDetails",
                "kind": "LinkedField",
                "name": "classificationLevelDetails",
                "plural": false,
                "selections": [
                  {
                    "condition": "useClassificationLevelV2",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "ContentDataClassificationLevel",
                        "kind": "LinkedField",
                        "name": "classificationLevel",
                        "plural": false,
                        "selections": (v134/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "useClassificationLevelV2",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ContentDataClassificationLevel",
                        "kind": "LinkedField",
                        "name": "classificationLevelV2",
                        "plural": false,
                        "selections": (v134/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "featureEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "source"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isReclassificationPermitted"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canManageSpaceSettings"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "classificationControlSetting"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "userOverrideSetting"
                  }
                ]
              }
            ]
          },
          (v93/*: any*/),
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  (v131/*: any*/)
                ]
              },
              (v97/*: any*/)
            ]
          },
          {
            "condition": "includeRendererAssetsMedia",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v98/*: any*/)
            ]
          },
          {
            "condition": "isSSR",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "MapOfStringToFormattedBody",
                "kind": "LinkedField",
                "name": "macroRenderedOutput",
                "plural": true,
                "selections": [
                  (v46/*: any*/),
                  {
                    "concreteType": "FormattedBody",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      (v43/*: any*/),
                      (v61/*: any*/),
                      {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": (v66/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v99/*: any*/)
        ]
      },
      {
        "args": (v100/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v101/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v49/*: any*/)
              },
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v102/*: any*/),
                      (v110/*: any*/),
                      (v111/*: any*/),
                      (v109/*: any*/),
                      (v103/*: any*/),
                      (v104/*: any*/),
                      (v108/*: any*/),
                      (v105/*: any*/),
                      (v107/*: any*/),
                      (v106/*: any*/),
                      (v114/*: any*/),
                      (v113/*: any*/)
                    ]
                  },
                  (v112/*: any*/),
                  (v115/*: any*/)
                ]
              }
            ]
          },
          (v116/*: any*/),
          (v117/*: any*/),
          (v119/*: any*/)
        ]
      },
      (v120/*: any*/),
      {
        "condition": "includeRovoMentionIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v121/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentStudioAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v122/*: any*/),
                      (v34/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": (v123/*: any*/),
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                  (v125/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryKeyPhrase",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "keyPhrase"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoveryKeyPhraseConnection"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeExternalLabels",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v124/*: any*/),
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              {
                "kind": "ScalarField",
                "name": "kind"
              },
              (v40/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8095f723e4b598338c3c3c8c18e763ad",
    "id": "c4a61a337d185f6e4afefb5bbff2cb0c4bc7f4a4776f29c7eed0049af5f812ec",
    "metadata": {},
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$includeRovoMentionIdentity:Boolean=false,$cloudId:String=\"\",$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsCustomChrome:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$includeConnectionAncestors:Boolean=false,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeNumberedHeadings:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$includeContentHeader:Boolean=false,$includeSmartCreateFeedback:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String,$includeExternalLabels:Boolean=false,$externalLabelsCloudId:ID=\"\",$externalLabelsAri:ID=\"\"){mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},agentStudio_getAgents(cloudId:$cloudId,product:\"confluence\",first:1,input:{creatorTypes:[ROVO_CHAT]})@include(if:$includeRovoMentionIdentity)@optIn(to:\"AgentStudio\"){edges{node{identityAccountId,id}}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...useExternalLabels_query_2n00s0@include(if:$includeExternalLabels),spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_1jvjSB@include(if:$includeBylineContributors)\n    ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n    ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias,type},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_1bw81T@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n    pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n    coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n    hasInheritedRestrictions@include(if:$includeRestrictions)\n    hasRestrictions@include(if:$includeRestrictions)\n    hasViewRestrictions@include(if:$includeRestrictions)\n    title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n    labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n    contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n    ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n    title@include(if:$includeAudioContent)\n    subType@include(if:$includeAudioContent)\n    emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n    history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n    links@include(if:$includeAudioContent){webui,base}\n    audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n    ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n    ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content_4MZOe@include(if:$includeClassification),...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},numberedHeadingsPublished:properties(key:\"numbered-headings-published\")@include(if:$includeNumberedHeadings){nodes{id,key,value}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},body@include(if:$includeRendererAssetsMedia){atlas_doc_format{mediaToken{token}}}\n    ...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){id@include(if:$includeRendererAssetsCustomChrome)\n    settings@include(if:$includeRendererAssetsCustomChrome){customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}},...ContentHeader_space@include(if:$includeContentHeader),...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLine_content_1jvjSB on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}},ancestors@include(if:$includeConnectionAncestors){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}}}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment ContentHeader_content_1bw81T on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...SmartCreateFeedbackBanner_content@include(if:$includeSmartCreateFeedback),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_1jvjSB on Content{...ContentTitle_content_2SjeOj,...ByLine_content_1jvjSB,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},numberedHeadingsPublished:properties(key:\"numbered-headings-published\")@include(if:$includeNumberedHeadings){nodes{id,key,value}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment SmartCreateFeedbackBanner_content on Content{title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useExternalLabels_query_2n00s0 on Query{confluence_externalLabels(cloudId:$externalLabelsCloudId,id:$externalLabelsAri){id,kind,name}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "1da9d61d32cc1ce4c4294a459445d8d2";

export default node;
